module.exports = __webpack_public_path__ + "img/flow3.bb747c64.png";